import React, { createContext, useContext, useState, useEffect } from 'react';

// Configuration des devises
const CURRENCIES = {
  CFA: { symbol: 'CFA', name: 'Franc CFA', rate: 1, decimals: 0 },
  EUR: { symbol: '€', name: 'Euro', rate: 1 / 655.957, decimals: 2 },
  USD: { symbol: '$', name: 'Dollar US', rate: 1 / 610, decimals: 2 },
  GBP: { symbol: '£', name: 'Livre Sterling', rate: 1 / 760, decimals: 2 },
  MAD: { symbol: 'DH', name: 'Dirham Marocain', rate: 1 / 62, decimals: 2 },
  XOF: { symbol: 'XOF', name: 'Franc CFA BCEAO', rate: 1, decimals: 0 },
};

// Configuration des langues
const LANGUAGES = {
  fr: { name: 'Français', flag: '🇫🇷' },
  en: { name: 'English', flag: '🇬🇧' },
  es: { name: 'Español', flag: '🇪🇸' },
};

// Traductions
const TRANSLATIONS = {
  fr: {
    // Navigation
    production: 'Production',
    maintenance: 'Maintenance',
    direction: 'Direction',
    zones: 'Zones',
    comparison: 'Avant/Après',
    alerts: 'Alertes & KPIs',
    productionMetrics: 'Production & Ratios',
    multiSite: 'Multi-Sites',
    logout: 'Déconnexion',
    
    // Dashboard Direction
    directionDashboard: 'Tableau de Bord Direction',
    strategicIndicators: 'Indicateurs stratégiques et analyse financière',
    monthlyEnergyCost: 'Coût Énergétique Mensuel',
    energyCostLabel: 'Coût Énergétique',
    consumptionLabel: 'Consommation',
    monthlyConsumption: 'Consommation Mensuelle',
    carbonFootprint: 'Empreinte Carbone',
    savingsPotential: 'Potentiel d\'Économie',
    financialAnalysis: 'Analyse Financière',
    avgCostPerKwh: 'Coût moyen par kWh',
    costToday: 'Coût aujourd\'hui',
    monthlyProjection: 'Projection mensuelle',
    avoidedPenalties: 'Pénalités évitées (cosφ)',
    performanceGoals: 'Objectifs de Performance',
    powerFactor: 'Facteur de puissance',
    energyIntensity: 'Intensité énergétique',
    carbonReduction: 'Réduction empreinte carbone',
    goalAchieved: 'Objectif atteint',
    remaining: 'restant',
    roiSensors: 'ROI Capteurs Accuenergy',
    annualSavings: 'Économies annuelles estimées',
    linePerformance: 'Performance par Ligne de Production',
    weeklyCost: 'Coût hebdo',
    dailyEnergy: 'Énergie/jour',
    efficiency: 'Efficacité',
    availability: 'Disponibilité',
    monthlyTrends: 'Tendances Mensuelles',
    consumptionTrends: 'Tendances de Consommation',
    annualTrendsChart: 'Graphique des tendances annuelles',
    energyCostsPowerFactor: 'Énergie, coûts et facteur de puissance sur 12 mois',
    dataAvailable: 'Données disponibles',
    months: 'mois',
    strategicActions: 'Actions Stratégiques Recommandées',
    energyOptimization: 'Optimisation Énergétique',
    pfImprovement: 'Amélioration du facteur de puissance',
    timeSlotOptimization: 'Optimisation des plages horaires',
    harmonicsReduction: 'Réduction harmoniques',
    priorityInvestments: 'Investissements Prioritaires',
    vfdAdditional: 'Variateurs de vitesse supplémentaires',
    harmonicFilters: 'Filtres harmoniques sur ligne broyage',
    ledLighting: 'Éclairage LED zones de production',
    year: 'an',
    perYear: '/an',
    perMonth: '/mois',
    
    // Dashboard Maintenance
    maintenanceDashboard: 'Tableau de Bord Maintenance',
    energyQuality: 'Qualité de l\'énergie et surveillance des composants',
    
    // Dashboard Production
    productionDashboard: 'Tableau de Bord Production',
    realTimeMonitoring: 'Monitoring temps réel par ligne',
    
    // Alertes
    recentAlerts: 'Alertes Récentes',
    viewAll: 'Voir tout',
    newAlerts: 'nouvelles alertes',
    critical: 'Critique',
    warning: 'Attention',
    info: 'Information',
    
    // Common
    systemStatus: 'État Système',
    activeSensors: 'Capteurs actifs',
    connection: 'Connexion',
    stable: 'Stable',
    preferences: 'Préférences',
    currency: 'Devise',
    language: 'Langue',
    
    // Dashboard Zones
    zonesDashboard: 'Vue par Zones de Production',
    zonesSubtitle: 'Monitoring spatial de l\'usine',
    zoneOverview: 'Vue d\'ensemble des Zones',
    totalPower: 'Puissance Totale',
    avgPowerFactor: 'Fact. Puissance Moy.',
    activeWarnings: 'Alertes Actives',
    zoneDetails: 'Détails de la Zone',
    linesInZone: 'Lignes de la zone',
    operational: 'Opérationnel',
    avgTemp: 'Temp. Moy.',
    
    // Dashboard Comparison
    comparisonDashboard: 'Comparaison Avant/Après',
    comparisonSubtitle: 'Analyse d\'impact de la solution de compensation',
    currentReduction: 'Réduction Courant',
    energySavings: 'Économies Énergie',
    costSavings: 'Économies Coûts',
    roiProgress: 'Progression ROI',
    before: 'Avant',
    after: 'Après',
    savings: 'Économies',
    dailyComparison: 'Comparaison Journalière',
    comparisonChart: 'Graphique de comparaison',
    yearOverYear: 'Comparaison Annuelle',
    paybackPeriod: 'Délai de Récupération',
    
    // Dashboard Alerts
    alertsDashboard: 'Alertes & KPIs Personnalisés',
    alertsSubtitle: 'Système d\'alertes et indicateurs configurables',
    temperatureMonitoring: 'Surveillance Température',
    componentHealth: 'Santé des Composants',
    customKPIs: 'KPIs Personnalisés',
    kpiSettings: 'Paramètres KPIs',
    addKPI: 'Ajouter KPI',
    threshold: 'Seuil',
    unit: 'Unité',
    enabled: 'Activé',
    workingHours: 'Heures de fonctionnement',
    avgHarmonics: 'Harmoniques moy.',
    nextMaintenance: 'Prochain entretien',
    
    // Dashboard Production Metrics
    productionMetricsDashboard: 'Métriques de Production',
    productionMetricsSubtitle: 'Intégration données production et énergie',
    dailyProduction: 'Production Quotidienne',
    energyIntensityMetric: 'Intensité Énergétique',
    costPerTonne: 'Coût par Tonne',
    productionEfficiency: 'Efficacité Production',
    tonnes: 'tonnes',
    targetObjective: 'Objectif',
    weeklyTrends: 'Tendances Hebdomadaires',
    productionVsEnergy: 'Production vs Énergie',
    optimizationPotential: 'Potentiel d\'Optimisation',
    
    // Dashboard Multi-Site
    multiSiteDashboard: 'Vue Multi-Sites',
    multiSiteSubtitle: 'Monitoring global des installations en Afrique',
    interactiveMap: 'Carte Interactive des Sites',
    clickMarkers: 'Cliquez sur les marqueurs pour voir les détails',
    siteList: 'Liste des Sites',
    siteDetails: 'Détails du Site',
    online: 'En ligne',
    offline: 'Hors ligne',
    monthlySavings: 'Économies mensuelles',
    selectSite: 'Sélectionner un site',
  },
  en: {
    // Navigation
    production: 'Production',
    maintenance: 'Maintenance',
    direction: 'Management',
    zones: 'Zones',
    comparison: 'Before/After',
    alerts: 'Alerts & KPIs',
    productionMetrics: 'Production & Ratios',
    multiSite: 'Multi-Site',
    logout: 'Logout',
    
    // Dashboard Direction
    directionDashboard: 'Management Dashboard',
    strategicIndicators: 'Strategic indicators and financial analysis',
    monthlyEnergyCost: 'Monthly Energy Cost',
    energyCostLabel: 'Energy Cost',
    consumptionLabel: 'Consumption',
    monthlyConsumption: 'Monthly Consumption',
    carbonFootprint: 'Carbon Footprint',
    savingsPotential: 'Savings Potential',
    financialAnalysis: 'Financial Analysis',
    avgCostPerKwh: 'Average cost per kWh',
    costToday: 'Cost today',
    monthlyProjection: 'Monthly projection',
    avoidedPenalties: 'Avoided penalties (PF)',
    performanceGoals: 'Performance Goals',
    powerFactor: 'Power factor',
    energyIntensity: 'Energy intensity',
    carbonReduction: 'Carbon footprint reduction',
    goalAchieved: 'Goal achieved',
    remaining: 'remaining',
    roiSensors: 'ROI Accuenergy Sensors',
    annualSavings: 'Estimated annual savings',
    linePerformance: 'Performance by Production Line',
    weeklyCost: 'Weekly cost',
    dailyEnergy: 'Daily energy',
    efficiency: 'Efficiency',
    availability: 'Availability',
    monthlyTrends: 'Monthly Trends',
    consumptionTrends: 'Consumption Trends',
    annualTrendsChart: 'Annual trends chart',
    energyCostsPowerFactor: 'Energy, costs and power factor over 12 months',
    dataAvailable: 'Data available',
    months: 'months',
    strategicActions: 'Recommended Strategic Actions',
    energyOptimization: 'Energy Optimization',
    pfImprovement: 'Power factor improvement',
    timeSlotOptimization: 'Time slot optimization',
    harmonicsReduction: 'Harmonics reduction',
    priorityInvestments: 'Priority Investments',
    vfdAdditional: 'Additional variable frequency drives',
    harmonicFilters: 'Harmonic filters on grinding line',
    ledLighting: 'LED lighting in production areas',
    year: 'year',
    perYear: '/year',
    perMonth: '/month',
    
    // Dashboard Maintenance
    maintenanceDashboard: 'Maintenance Dashboard',
    energyQuality: 'Energy quality and component monitoring',
    
    // Dashboard Production
    productionDashboard: 'Production Dashboard',
    realTimeMonitoring: 'Real-time monitoring by line',
    
    // Alertes
    recentAlerts: 'Recent Alerts',
    viewAll: 'View all',
    newAlerts: 'new alerts',
    critical: 'Critical',
    warning: 'Warning',
    info: 'Information',
    
    // Common
    systemStatus: 'System Status',
    activeSensors: 'Active sensors',
    connection: 'Connection',
    stable: 'Stable',
    preferences: 'Preferences',
    currency: 'Currency',
    language: 'Language',
    
    // Dashboard Zones
    zonesDashboard: 'Production Zones View',
    zonesSubtitle: 'Spatial monitoring of the factory',
    zoneOverview: 'Zones Overview',
    totalPower: 'Total Power',
    avgPowerFactor: 'Avg. Power Factor',
    activeWarnings: 'Active Warnings',
    zoneDetails: 'Zone Details',
    linesInZone: 'Lines in zone',
    operational: 'Operational',
    avgTemp: 'Avg. Temp.',
    
    // Dashboard Comparison
    comparisonDashboard: 'Before/After Comparison',
    comparisonSubtitle: 'Impact analysis of the compensation solution',
    currentReduction: 'Current Reduction',
    energySavings: 'Energy Savings',
    costSavings: 'Cost Savings',
    roiProgress: 'ROI Progress',
    before: 'Before',
    after: 'After',
    savings: 'Savings',
    dailyComparison: 'Daily Comparison',
    comparisonChart: 'Comparison chart',
    yearOverYear: 'Year-over-Year Comparison',
    paybackPeriod: 'Payback Period',
    
    // Dashboard Alerts
    alertsDashboard: 'Alerts & Custom KPIs',
    alertsSubtitle: 'Alert system and configurable indicators',
    temperatureMonitoring: 'Temperature Monitoring',
    componentHealth: 'Component Health',
    customKPIs: 'Custom KPIs',
    kpiSettings: 'KPI Settings',
    addKPI: 'Add KPI',
    threshold: 'Threshold',
    unit: 'Unit',
    enabled: 'Enabled',
    workingHours: 'Working hours',
    avgHarmonics: 'Avg. harmonics',
    nextMaintenance: 'Next maintenance',
    
    // Dashboard Production Metrics
    productionMetricsDashboard: 'Production Metrics',
    productionMetricsSubtitle: 'Production and energy data integration',
    dailyProduction: 'Daily Production',
    energyIntensityMetric: 'Energy Intensity',
    costPerTonne: 'Cost per Tonne',
    productionEfficiency: 'Production Efficiency',
    tonnes: 'tonnes',
    targetObjective: 'Target',
    weeklyTrends: 'Weekly Trends',
    productionVsEnergy: 'Production vs Energy',
    optimizationPotential: 'Optimization Potential',
    
    // Dashboard Multi-Site
    multiSiteDashboard: 'Multi-Site View',
    multiSiteSubtitle: 'Global monitoring of facilities in Africa',
    interactiveMap: 'Interactive Site Map',
    clickMarkers: 'Click on markers to see details',
    siteList: 'Site List',
    siteDetails: 'Site Details',
    online: 'Online',
    offline: 'Offline',
    monthlySavings: 'Monthly savings',
    selectSite: 'Select a site',
  },
  es: {
    // Navigation
    production: 'Producción',
    maintenance: 'Mantenimiento',
    direction: 'Dirección',
    zones: 'Zonas',
    comparison: 'Antes/Después',
    alerts: 'Alertas y KPIs',
    productionMetrics: 'Producción y Ratios',
    multiSite: 'Multi-Sitio',
    logout: 'Cerrar sesión',
    
    // Dashboard Direction
    directionDashboard: 'Panel de Dirección',
    strategicIndicators: 'Indicadores estratégicos y análisis financiero',
    monthlyEnergyCost: 'Costo Energético Mensual',
    energyCostLabel: 'Costo Energético',
    consumptionLabel: 'Consumo',
    monthlyConsumption: 'Consumo Mensual',
    carbonFootprint: 'Huella de Carbono',
    savingsPotential: 'Potencial de Ahorro',
    financialAnalysis: 'Análisis Financiero',
    avgCostPerKwh: 'Costo promedio por kWh',
    costToday: 'Costo hoy',
    monthlyProjection: 'Proyección mensual',
    avoidedPenalties: 'Penalidades evitadas (FP)',
    performanceGoals: 'Objetivos de Rendimiento',
    powerFactor: 'Factor de potencia',
    energyIntensity: 'Intensidad energética',
    carbonReduction: 'Reducción huella de carbono',
    goalAchieved: 'Objetivo alcanzado',
    remaining: 'restante',
    roiSensors: 'ROI Sensores Accuenergy',
    annualSavings: 'Ahorros anuales estimados',
    linePerformance: 'Rendimiento por Línea de Producción',
    weeklyCost: 'Costo semanal',
    dailyEnergy: 'Energía/día',
    efficiency: 'Eficiencia',
    availability: 'Disponibilidad',
    monthlyTrends: 'Tendencias Mensuales',
    consumptionTrends: 'Tendencias de Consumo',
    annualTrendsChart: 'Gráfico de tendencias anuales',
    energyCostsPowerFactor: 'Energía, costos y factor de potencia en 12 meses',
    dataAvailable: 'Datos disponibles',
    months: 'meses',
    strategicActions: 'Acciones Estratégicas Recomendadas',
    energyOptimization: 'Optimización Energética',
    pfImprovement: 'Mejora del factor de potencia',
    timeSlotOptimization: 'Optimización de horarios',
    harmonicsReduction: 'Reducción de armónicos',
    priorityInvestments: 'Inversiones Prioritarias',
    vfdAdditional: 'Variadores de frecuencia adicionales',
    harmonicFilters: 'Filtros de armónicos en línea de molienda',
    ledLighting: 'Iluminación LED en áreas de producción',
    year: 'año',
    perYear: '/año',
    perMonth: '/mes',
    
    // Dashboard Maintenance
    maintenanceDashboard: 'Panel de Mantenimiento',
    energyQuality: 'Calidad de energía y monitoreo de componentes',
    
    // Dashboard Production
    productionDashboard: 'Panel de Producción',
    realTimeMonitoring: 'Monitoreo en tiempo real por línea',
    
    // Alertes
    recentAlerts: 'Alertas Recientes',
    viewAll: 'Ver todo',
    newAlerts: 'nuevas alertas',
    critical: 'Crítico',
    warning: 'Advertencia',
    info: 'Información',
    
    // Common
    systemStatus: 'Estado del Sistema',
    activeSensors: 'Sensores activos',
    connection: 'Conexión',
    stable: 'Estable',
    preferences: 'Preferencias',
    currency: 'Moneda',
    language: 'Idioma',
    
    // Dashboard Zones
    zonesDashboard: 'Vista por Zonas de Producción',
    zonesSubtitle: 'Monitoreo espacial de la fábrica',
    zoneOverview: 'Vista General de Zonas',
    totalPower: 'Potencia Total',
    avgPowerFactor: 'Factor Pot. Prom.',
    activeWarnings: 'Alertas Activas',
    zoneDetails: 'Detalles de la Zona',
    linesInZone: 'Líneas en la zona',
    operational: 'Operacional',
    avgTemp: 'Temp. Prom.',
    
    // Dashboard Comparison
    comparisonDashboard: 'Comparación Antes/Después',
    comparisonSubtitle: 'Análisis de impacto de la solución de compensación',
    currentReduction: 'Reducción de Corriente',
    energySavings: 'Ahorro de Energía',
    costSavings: 'Ahorro de Costos',
    roiProgress: 'Progreso ROI',
    before: 'Antes',
    after: 'Después',
    savings: 'Ahorros',
    dailyComparison: 'Comparación Diaria',
    comparisonChart: 'Gráfico de comparación',
    yearOverYear: 'Comparación Anual',
    paybackPeriod: 'Período de Recuperación',
    
    // Dashboard Alerts
    alertsDashboard: 'Alertas y KPIs Personalizados',
    alertsSubtitle: 'Sistema de alertas e indicadores configurables',
    temperatureMonitoring: 'Monitoreo de Temperatura',
    componentHealth: 'Salud de Componentes',
    customKPIs: 'KPIs Personalizados',
    kpiSettings: 'Configuración de KPIs',
    addKPI: 'Agregar KPI',
    threshold: 'Umbral',
    unit: 'Unidad',
    enabled: 'Habilitado',
    workingHours: 'Horas de funcionamiento',
    avgHarmonics: 'Armónicos prom.',
    nextMaintenance: 'Próximo mantenimiento',
    
    // Dashboard Production Metrics
    productionMetricsDashboard: 'Métricas de Producción',
    productionMetricsSubtitle: 'Integración de datos de producción y energía',
    dailyProduction: 'Producción Diaria',
    energyIntensityMetric: 'Intensidad Energética',
    costPerTonne: 'Costo por Tonelada',
    productionEfficiency: 'Eficiencia de Producción',
    tonnes: 'toneladas',
    targetObjective: 'Objetivo',
    weeklyTrends: 'Tendencias Semanales',
    productionVsEnergy: 'Producción vs Energía',
    optimizationPotential: 'Potencial de Optimización',
    
    // Dashboard Multi-Site
    multiSiteDashboard: 'Vista Multi-Sitio',
    multiSiteSubtitle: 'Monitoreo global de instalaciones en África',
    interactiveMap: 'Mapa Interactivo de Sitios',
    clickMarkers: 'Haga clic en los marcadores para ver detalles',
    siteList: 'Lista de Sitios',
    siteDetails: 'Detalles del Sitio',
    online: 'En línea',
    offline: 'Fuera de línea',
    monthlySavings: 'Ahorros mensuales',
    selectSite: 'Seleccionar sitio',
  }
};

const PreferencesContext = createContext();

export const PreferencesProvider = ({ children }) => {
  const [currency, setCurrency] = useState(() => {
    return localStorage.getItem('electra_currency') || 'CFA';
  });
  
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('electra_language') || 'fr';
  });

  // Persister les préférences
  useEffect(() => {
    localStorage.setItem('electra_currency', currency);
  }, [currency]);

  useEffect(() => {
    localStorage.setItem('electra_language', language);
  }, [language]);

  // Fonction de conversion de devise
  const convertCurrency = (valueInCFA) => {
    const curr = CURRENCIES[currency];
    const converted = valueInCFA * curr.rate;
    return converted.toFixed(curr.decimals);
  };

  // Formater avec symbole
  const formatCurrency = (valueInCFA) => {
    const curr = CURRENCIES[currency];
    const converted = valueInCFA * curr.rate;
    return `${converted.toFixed(curr.decimals)} ${curr.symbol}`;
  };

  // Traduction
  const t = (key) => {
    return TRANSLATIONS[language]?.[key] || TRANSLATIONS['fr'][key] || key;
  };

  const currencySymbol = CURRENCIES[currency].symbol;
  const currentCurrency = CURRENCIES[currency];

  return (
    <PreferencesContext.Provider value={{
      // Devise
      currency,
      setCurrency,
      currencySymbol,
      currentCurrency,
      convertCurrency,
      formatCurrency,
      currencies: CURRENCIES,
      
      // Langue
      language,
      setLanguage,
      languages: LANGUAGES,
      t,
    }}>
      {children}
    </PreferencesContext.Provider>
  );
};

export const usePreferences = () => {
  const context = useContext(PreferencesContext);
  if (!context) {
    throw new Error('usePreferences must be used within PreferencesProvider');
  }
  return context;
};

export { CURRENCIES, LANGUAGES, TRANSLATIONS };
